import React, { useCallback } from 'react';
import { compact } from 'lodash-es';
import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';
/* Constants */
import { MATCH_LIST_CREATIVE_ID } from 'site-modules/shared/constants/incentives/electric-car-incentives';
import { TrackingConstant } from 'client/tracking/constant';
/* Utils */
import { EventToolbox } from 'client/utils/event-toolbox';
import { validation } from 'site-modules/shared/components/form-validation/validation';
/* Components */
import { StyledZipInput } from 'site-modules/shared/components/styled-zip-input/styled-zip-input';
import { Input } from 'site-modules/shared/components/inventory/input/input';
import { Link } from 'site-modules/shared/components/link/link';

import './ev-incentives-zip.scss';

export function trackFilterChange(filter, value) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
    event_data: {
      action_name: TrackingConstant.ACTION_TOOL_SELECT,
      subaction_name: 'filter_incentives',
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      action_cause: TrackingConstant.ACTION_CAUSE_USER_INPUT,
      creative_id: MATCH_LIST_CREATIVE_ID,
      value: compact([filter, value]).join(','),
    },
  });
}

export function EvIncentivesZip() {
  const onZipChange = useCallback(zip => {
    trackFilterChange('zip', zip);
  }, []);

  return (
    <div className="ev-incentives-form mb-1 mb-md-2">
      <div className="pb-1" data-testid="electric-car-filters-container">
        <StyledZipInput
          inputClasses="search-by-zip-input standalone-zip size-16 pos-r"
          onValidate={validation.validateZip}
          getTracking={{ 'data-tracking-id': 'provide_zip_code' }}
          trackingCbOnZipChange={onZipChange}
          btnColor="primary-b"
          btnClassname="fw-medium"
          inputComponent={Input}
          inputSize=""
          label="Incentives near"
          labelClasses="fw-medium me-0_5"
        />
      </div>
      <Row>
        <Col xs={12} lg={8} className="small">
          <span className="text-cool-gray-40">
            Edmunds does not retain or share any data that you provide through this tool. We make every effort to
            provide accurate information, but please verify programs and eligibility before purchasing a vehicle. This
            information is provided subject to our{' '}
          </span>
          <Link className="text-primary-darker text-underline" to="/about/visitor-agreement.html">
            Visitor Agreement
          </Link>
          <span className="text-cool-gray-40">.</span>
        </Col>
      </Row>
    </div>
  );
}
